const getters = {
  isMobile: (state) => state.is_mobile ?? false,
  feature: () => window.global_theme_object.feature_enabled ?? {},
  loaded: (state) => state.loaded,
  menuLoaded: (state) => state.menuLoaded ?? state.loaded, // Fallback for existing sessions
  isB2B: (state) => state.b2bUser,
  devMode: (state) => state.devMode ?? false,
  loadingStore: (state) => state.loadingStore,
  brandsmenu: (state) => state.menus?.brandsmenu ?? state.brandsmenu ?? false,
  brandmenus: (state) => state.menus?.brandmenus ?? state.brandmenus ?? false,
  usp: (state) => state.usp,
  validMarkets: () => {
    const data = window.global_theme_object.markets.markets;
    return Object.values(data).map((item) => item.country_code);
  },
  currentMarket: () => window.global_theme_object.currency.country ?? 'IE'
};
export default getters;
